"use client";

import { motion } from "framer-motion";

export function AmbientCanvas() {
  return (
    <div className="absolute inset-0 z-0 overflow-hidden pointer-events-none opacity-60 transition-colors duration-700">
      {/* 
          CINEMATIC VOLUMETRIC ATMOSPHERE - FULL REFACTOR
          Theme-Aware: Deep Space (Dark) / Clean Gallery (Light)
      */}

      {/* 1. Base Gradient Overlay - Clean transitions, no muddy grays */}
      {/* Light: Transparent to clean white. Dark: Transparent to pure black. */}
      <div className="absolute inset-0 bg-linear-to-b from-transparent via-transparent to-(--bg-primary)/90 transition-colors duration-700 pointer-events-none" />

      {/* 2. Primary Light Source (Top Left) - Volumetric Tint */}
      {/* Light: Subtle Blue-ish tint. Dark: Cyan Cyber tint (Reduced opacity for deep black contrast). */}
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_20%_20%,rgba(56,189,248,0.03)_0%,transparent_50%)] dark:bg-[radial-gradient(circle_at_20%_20%,rgba(6,182,212,0.1)_0%,transparent_50%)] transition-all duration-700" />

      {/* 3. Ambient Grounding (Bottom Right) - Warm/Purple Tint */}
      {/* Light: Subtle violet. Dark: Deep Magenta (Reduced opacity). */}
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_80%_80%,rgba(168,85,247,0.03)_0%,transparent_50%)] dark:bg-[radial-gradient(circle_at_80%_80%,rgba(192,38,211,0.1)_0%,transparent_50%)] transition-all duration-700" />

      {/* 4. HOLOGRAPHIC AURA GLOW */}
      {/* CRITICAL: Uses 'multiply' in Light Mode to be visible against white. 'screen' in Dark Mode to glow against black. */}
      <motion.div
        animate={{
          rotate: [0, 360],
          scale: [0.8, 1.2, 0.8],
          opacity: [0.5, 0.8, 0.5],
        }}
        transition={{
          rotate: { duration: 25, repeat: Infinity, ease: "linear" },
          scale: { duration: 10, repeat: Infinity, ease: "easeInOut" },
          opacity: { duration: 5, repeat: Infinity, ease: "easeInOut" },
        }}
        className="absolute top-1/2 right-0 -translate-y-1/2 w-[60vw] h-[60vh] md:w-[50vw] md:h-[50vh] rounded-full blur-[100px] pointer-events-none mix-blend-multiply dark:mix-blend-screen opacity-50 dark:opacity-100"
        style={{
          background:
            "conic-gradient(from 0deg, #ff0000, #ff3b1c, #ff4d00, #f99b0d, #ffbf00, #fef30d, #4cc211, #00b300, #00a3e0, #0066ff, #5900ff, #a200ff, #f200ff, #b300a4)",
          // Red, Red-Orange, Orange, Deep Orange, Gold, Bright Yellow, Lime Green, Green, Light Blue, Vivid Blue, Vivid Purple, Bright Purple, Intense Pink, Magenta -> Matches Blob Colors
        }}
      />

      {/* 5. Cinematic Grain - Texture */}
      <div className="absolute inset-0 bg-[url('/images/noise.png')] opacity-[0.04] md:opacity-[0.15] mix-blend-overlay dark:mix-blend-overlay contrast-150" />
    </div>
  );
}
